export const maxWidthMd = 'screen and (max-width: 1024px)';
export const maxWidthS = 'screen and (max-width: 768px)';
export const maxWidthXs = 'screen and (max-width: 568px)';
export const maxWidthLg = 'screen and (max-width: 1440px)';
export const minWidthLg = 'screen and (min-width: 1440px)';
